import { Asset } from '@/api/generatedApi';
import { BodyText } from '@/components/BodyText';
import { Box, IconButton, styled } from '@mui/material';
import { useState } from 'react';
import { TbLayoutSidebarLeftExpand, TbLayoutSidebarRightExpand } from 'react-icons/tb';
import { ComparePageSecondaryNav } from '@/components/ComparePage/ComparePageSecondaryNav';

const ComparePageContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
});

const Header = styled(Box)({
  display: 'flex',
  minHeight: '53px',
  alignItems: 'center',
  margin: '6px 6px 0 6px',
  gap: '6px',
});

const NavHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: theme.palette.action.hover,
  borderRight: `1px solid ${theme.palette.divider}`,
  padding: '12px 16px',
  minHeight: '53px',
  color: theme.palette.text.primary,
  transition: 'width 0.3s ease',
}));

const NavHeaderInner = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

const NavHeaderActions = styled(Box)({
  marginLeft: 'auto',
  marginTop: '2px',
  display: 'flex',
  gap: '6px',
  alignItems: 'center',
});

const ToggleButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.secondary,
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.12)',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}));

const ContentArea = styled(Box)({
  display: 'flex',
  flex: 1,
  width: '100%',
  margin: '0 6px 6px 6px',
  minHeight: 0,
});

const Workspace = styled(Box)({
  flex: 1,
  padding: '6px',
});

const Spacer = styled(Box)({
  flex: 1,
});

const MAX_ASSETS = 10;

export const GridCompareAssets = () => {
  const [selectedAssets, setSelectedAssets] = useState<Asset[]>([]);
  const [isNavCollapsed, setIsNavCollapsed] = useState(false);

  const handleAssetToggle = (asset: Asset) => {
    setSelectedAssets(previous => {
      const isSelected = previous.some(a => a.id === asset.id);
      if (isSelected) {
        return previous.filter(a => a.id !== asset.id);
      } else {
        if (previous.length >= MAX_ASSETS) {
          return previous;
        }
        return [...previous, asset];
      }
    });
  };

  const handleClearAll = () => {
    setSelectedAssets([]);
  };

  return (
    <ComparePageContainer>
      <Header>
        <NavHeader
          sx={{
            width: isNavCollapsed ? '120px' : '360px',
          }}
        >
          <NavHeaderInner>
            <BodyText>Compare</BodyText>
            <NavHeaderActions>
              {isNavCollapsed ? (
                <ToggleButton size='small' onClick={() => setIsNavCollapsed(false)}>
                  <TbLayoutSidebarLeftExpand style={{ fontSize: '18px' }} />
                </ToggleButton>
              ) : (
                <ToggleButton size='small' onClick={() => setIsNavCollapsed(true)}>
                  <TbLayoutSidebarRightExpand style={{ fontSize: '18px' }} />
                </ToggleButton>
              )}
            </NavHeaderActions>
          </NavHeaderInner>
        </NavHeader>
        <Spacer />
      </Header>
      <ContentArea>
        <ComparePageSecondaryNav
          selectedAssets={selectedAssets}
          onAssetClick={handleAssetToggle}
          onClearAll={handleClearAll}
          maxAssets={MAX_ASSETS}
          isCollapsed={isNavCollapsed}
        />
        <Workspace>{/* TODO: Display selected assets in comparison workspace */}</Workspace>
      </ContentArea>
    </ComparePageContainer>
  );
};
